import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'
import { Room, RemoteAudioTrack } from 'twilio-video'
import selectIsLocalParticipantDialedIn from '../selectIsLocalParticipantDialedIn'
import username from '../../../lib/username'

/**
 * Returns the first enabled audio track for the dialed-in participant
 * @param state The Redux state
 */

const getRoom = (state: State): Room | null => state.room.room
const getBTID = (state: State): string | null => state.user.BTID
const getEnabledTracks = (state: State): string[] => state.tracks.enabledAudioTracks

export default createSelector(
  [
    selectIsLocalParticipantDialedIn,
    getRoom,
    getBTID,
    getEnabledTracks
  ],
  (isLocalParticipantDialedIn, room, BTID, enabledTracks): RemoteAudioTrack | null => {

    if (!room || !isLocalParticipantDialedIn) return null

    for (const [ , participant ] of room.participants.entries()) {

      if (username.getPureUsername(participant.identity) === BTID) {

        for (const [ , trackPublication ] of participant.audioTracks.entries()) {

          if (enabledTracks.find(trackSid => trackSid === trackPublication.trackSid)) {

            return trackPublication.track

          }

        }

      }

    }

    return null

  })
